import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getRfyTopicsFilterTopics,
  getTopicFilter,
} from '../../../../selectors/page';

import { Props } from './TopicFilterSlider';

export type StateProps = Pick<Props, 'topics' | 'topicFilter'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  topics: getRfyTopicsFilterTopics(state),
  topicFilter: getTopicFilter(state),
});

export default connect(mapStateToProps);
